import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import Sidebar from "./Sidebar";
import MobileNav from "./MobileNav";
import TerminalSidebar from "../terminal/TerminalSidebar";
import { appVariant } from "../../config/appVariant";

const AppShell = ({ children }) => {
	const location = useLocation();

	// Convert pathname to a valid class name (e.g., "/time-tracking/sub" -> "route-time-tracking")
	const routeClass = `${location.pathname.split("/")[1] || "home"}`;

	// Persist terminal state in localStorage
	const [isTerminalOpen, setIsTerminalOpen] = useState(() => {
		const saved = localStorage.getItem("terminal-open");
		return saved ? JSON.parse(saved) : false;
	});

	useEffect(() => {
		localStorage.setItem("terminal-open", JSON.stringify(isTerminalOpen));
	}, [isTerminalOpen]);

	const toggleTerminal = () => {
		setIsTerminalOpen(!isTerminalOpen);
	};

	return (
		<div className={`app-shell ${routeClass} ${isTerminalOpen ? "app-shell--terminal-open" : ""}`}>
			<Sidebar isLazloOpen={isTerminalOpen} onLazloToggle={toggleTerminal} />
			<main className="app-shell__main">
				{children}
			</main>
			{appVariant.showLazlo && (
				<TerminalSidebar isOpen={isTerminalOpen} onClose={toggleTerminal} />
			)}
			<MobileNav isLazloOpen={isTerminalOpen} onLazloToggle={toggleTerminal} />
		</div>
	);
};

export default AppShell;
